<template>
  <div class="payment-container">
    <div class="payment-info" v-if="dataDone">
      <div class="info-item">
        <div class="info-type">预约医生</div>
        <div class="info-content">{{orderBaseInfo.username}}</div>
      </div>
      <!-- 预约显示内容 -->
      <div class="info-item" v-if="orderType == 1">
        <div class="info-type">预约日期</div>
        <div class="info-content">{{orderBaseInfo.start_time | dateFilter('day')}} ({{orderBaseInfo.week}})</div>
      </div>
      <div class="info-item" v-if="orderType == 1">
        <div class="info-type">预约时间</div>
        <div class="info-content">{{orderBaseInfo.start_time | timeFilter}} - {{orderBaseInfo.end_time | timeFilter}}</div>
      </div>
      <!-- 随诊显示内容 -->
      <div class="info-item" v-if="orderType == 2">
        <div class="info-type">随诊时间</div>
        <div class="info-content">48 小时内</div>
      </div>
      <div class="info-item">
        <div class="info-type">医事服务费</div>
        <!-- 已预约状态需显示‘已支付’ -->
        <div class="info-content"><span class="money">{{orderBaseInfo.money}}元 <template v-if="isEnroll">（已支付）</template></span></div>
      </div>
    </div>
    <!-- 只支持微信支付 -->
    <div class="payment-way" @click="selectPayType(1)">
      <div class="wechat-pay">
        <icon icon-class="wechat-payment"></icon>微信支付
      </div>
      <icon class="payment-check" icon-class="cricle-check" v-if="payType=='wechat'"></icon>

    </div>
    <div class="payment-way" v-if="orderType==2&&couponCount" @click="selectPayType(2)">
      <div class="wechat-pay">
        <img src="@/assets/images/icons/coupon.png" style="width: 30px; margin-right: 10px;" />
        诊疗券支付({{couponCount}}张可用)</div>
      <icon class="payment-check" icon-class="cricle-check" v-if="payType=='coupon'"></icon>
    </div>
    <div class="payment-service">
      <!-- <div class="service-item">
        <div class="service-title">服务保障</div>
        <div class="service-content">100%医生本人<br>就诊前24小时可取消，全额退费</div>
      </div> -->
      <div class="service-item">
        <div class="service-title">就诊须知</div>
        <div class="service-content">
          <!-- 预约就诊须知 -->
          <ul v-if="orderType == 1">
            <li>1. 复诊时必须提供包含诊断的实体医疗机构的病历资料，针对同诊断复诊。</li>
            <li>2. 购买成功后请如实填写问诊单并发送给医生。 </li>
            <li>3. 医生将在预约时段回复您，逾期未回复您可选择继续等待或联系客服处理。</li>
            <li>4. 本服务有效期：预约诊疗时间段内有效。 </li>
            <li>5. 医生将与您通过图片、文字或语音进行交流。</li>
            <li>6. 医生将根据患者实际情况诊断开方、给出用药建议。 </li>
            <li>7. 问诊过程中请避免向医生咨询非患者本人的问题，否则医生有权提前结束诊疗。 </li>
            <li>8. 在线复诊过程中，若由于您无法提供实体医疗机构的诊断证明，或医生无法在线得出和您之前线下实体机构相同的诊断而无法为您开出处方和诊断的情况，将不会退还复诊费用。 </li>
            <li>9. 就诊前24小时可取消，全额退费。</li>
            <li>10. 购买即同意<router-link to="/patient/agreement">《用户注册协议》</router-link>及<router-link to="/patient/statement">《法律声明与隐私政策》</router-link>。</li>
          </ul>
          <!-- 随诊就诊须知 -->
          <ul v-if="orderType == 2">
            <li>1. 复诊时必须提供包含诊断的实体医疗机构的病历资料，针对同诊断复诊。 </li>
            <li>2. 购买成功后请如实填写问诊单并发送给医生，医生将按照接到问诊单先后顺序回复。</li>
            <li>3. 医生将在48小时内回复您，逾期未回复您可选择继续等待或联系客服处理。 </li>
            <li>4. 本服务有效期：成功发起实时问诊后的48小时内有效。</li>
            <li>5. 医生将与您通过图片、文字或语音进行交流。 </li>
            <li>6. 医生将根据患者实际情况诊断开方、给出用药建议。 </li>
            <li>7. 问诊过程中请避免向医生咨询非患者本人的问题，否则医生有权提前结束诊疗。 </li>
            <li>8. 在线复诊过程中，若由于您无法提供实体医疗机构的诊断证明，或医生无法在线得出和您之前线下实体机构相同的诊断而无法为您开出处方和诊断的情况，将不会退还复诊费用。 </li>
            <li>9. 购买即同意<router-link to="/patient/agreement">《用户注册协议》</router-link>及<router-link to="/patient/statement">《法律声明与隐私政策》</router-link>。</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="agreement-tip" v-if="!isEnroll" @click="isAgree = !isAgree" :class="{'checked': isAgree}">
      <icon icon-class="checked" />我已阅读并同意<span @click.stop="agreementShow = true">《患者知情同意书》</span></div>
    <!-- 非预约状态显示预约按钮 -->
    <div class="order" v-if="!isEnroll"><button class="order-button" @click="confirmOrder" :disabled="prepaying">{{orderType == 1 ? '确认预约' : '立即问诊'}}</button></div>
    <!-- 已预约状态显示取消预约按钮 -->
    <div class="ordered-control" v-else>
      <button class="cancel-button" @click="back">返回</button>
      <button class="cancel-button" @click="cancelOrderShow = true" :disabled="!allowCancel">取消预约</button>
    </div>
    <status-dialog v-if="invalidOrderShow" status-type="error" title="订单失效" sub-title="订单支付超时，感谢您的理解！" @close="invalidOrderShow = false"></status-dialog>
    <x-dialog v-if="cancelOrderShow" title="取消预约" @close="cancelOrderShow = false">
      <div class="dialog-content">
        <div class="text">是否取消本次预约诊疗日程</div>
        <div class="control">
          <button class="cancel" @click="cancelOrderShow = false">我再想想</button>
          <button class="confirm" @click="cancelOrderAction" :disabled="canceling">确定</button>
        </div>
      </div>
    </x-dialog>
    <x-dialog v-if="hasOrderShow" title="提醒" @close="hasOrderShow = false">
      <div class="dialog-content">
        <div class="text">
          <p class="error-time">{{hasOrderDate.startTime | orderTimeFormat}} - {{hasOrderDate.endTime | orderTimeFormat('time')}}</p>
          <div>已有预约诊疗日程，是否继续发起实时问诊</div>
        </div>
        <div class="control">
          <button class="cancel" @click="hasOrderShow = false">取消</button>
          <button class="confirm" @click="pay" :disabled="paying">继续</button>
        </div>
      </div>
    </x-dialog>
    <van-popup v-model="agreementShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          《患者知情同意书》
          <span class="close-popup" @click="agreementShow = false">关闭</span>
        </div>
        <div class="agreement-dialog-wrapper">
          <patient-pay-agreement />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .payment-container{
    min-height: 100vh;
    background: #F7F7F7;
    padding-top: 12px;
    padding-bottom: 64px;
    .payment-info{
      padding: 30px 20px 6px;
      background: #FFF;
      margin-bottom: 12px;
      .info-item{
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        margin-bottom: 24px;
        .info-type{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          width: 86px;
        }
        .info-content{
          font-size: 16px;
          line-height: 16px;
          font-weight: bold;
          color: @black;
          .money{
            color: @xile;
          }
        }
      }
    }
    .payment-way{
      margin-bottom: 12px;
      background: #FFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      padding: 0 20px;
      .wechat-pay{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        color: @black;
        svg{
          font-size: 32px;
          margin-right: 8px;
        }
      }
      .payment-check{
        font-size: 20px;
        color: @xile;
      }
    }
    .payment-service{
      padding: 28px 20px 6px;
      margin-bottom: 12px;
      background: #FFF;
      .service-item{
        margin-bottom: 24px;
        .service-title{
          font-size: 16px;
          line-height: 16px;
          color: @black;
          font-weight: bold;
          margin-bottom: 12px;
        }
        .service-content{
          font-size: 14px;
          line-height: 20px;
          color: @black;
          a{
            color: @xile;
          }
        }
      }
    }
    .agreement-tip{
      padding: 0 20px 24px;
      font-size: 14px;
      line-height: 14px;
      color: @black;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &.checked{
        svg{
          color: @xile;
        }
      }
      svg{
        position: relative;
        top: -1px;
        font-size: 12px;
        margin-right: 4px;
        color: #666;
      }
      span{
        color: @xile;
      }
    }
    .order{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 12px 20px;
      background: #FFF;
      box-shadow: 0px -2px 6px 0px rgba(199,163,97,0.06);
      .order-button{
        @button-base();
        width: 100%;
        height: 40px;
        box-shadow: 0px 2px 8px 0px rgba(0,132,138,0.3);
      }
    }
    .ordered-control{
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 12px 20px;
      background: #FFF;
      box-shadow: 0px -2px 6px 0px rgba(199,163,97,0.06);
      display: flex;
      justify-content: center;
      align-items: center;
      .cancel-button{
        @button-base();
        @button-border();
        flex: 1;
        height: 40px;
        &:disabled{
          border-color: #CCC;
          color: #999;
          opacity: 1;
        }
        &:first-child{
          margin-right: 15px;
        }
      }
    }
    .dialog-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        text-align: center;
        font-size: 14px;
        line-height: 22px;
        color: @black;
        font-weight: bold;
        .error-time{
          color: @error;
          font-size: 17px;
          line-height: 17px;
          font-weight: bold;
        }
        div{
          font-size: 15px;
          line-height: 15px;
          color: @black;
          margin-top: 8px;
          font-weight: normal;
        }
      }
      .control{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 40px;
        button{
          @button-base();
          width: 136px;
          height: 36px;
          &.cancel{
            @button-border();
            margin-right: 13px;
            border-color: #999;
            color: #666;
          }
        }
      }
    }
  }
  .popup-wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    background: #FFF;
    .popup-header{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      background: #F3F3F3;
      z-index: 100;
      .close-popup{
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        font-size: 13px;
        color: @black;
        font-weight: normal;
        background: transparent;
        border: 0;
      }
    }
    .agreement-dialog-wrapper{
      margin-top: 0;
      padding-top: 48px;
      height: calc(100%);
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  import statusDialog from '@/components/Common/statusDialog'
  import patientPayAgreement from '@/components/Agreement/patientPayAgreement'
  export default {
    data() {
      return {
        isEnroll: this.$route.query.enroll ? true : false,
        dataDone: false,
        orderType: this.$route.query.type,
        doc_id: this.$route.query.doc_id,
        orderBaseInfo: {},
        orderId: null,
        orderNumber: null,
        prepaying: false,
        paying: false,
        invalidOrderShow: false,
        allowCancel: false,
        canceling: false,
        cancelOrderShow: false,
        hasOrderShow: false,
        hasOrderDate: {
          startTime: null,
          endTime: null,
        },
        agreementShow: false,
        isAgree: true,
        payType: 'wechat',
        couponCount: 0,
        couponData: []
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      statusDialog,
      xDialog,
      patientPayAgreement
    },
    created() {
      this.$root.post('/getEnrollInfo', {
        doc_id: this.$route.query.doc_id,
        schedule_id: this.$route.query.schedule_id || null,
      }).then(data => {
        this.dataDone = true;
        console.log(data);
        if (this.isEnroll && data.is_cancel == 1) {
          this.allowCancel = true;
        }
        this.orderBaseInfo = data || {};
      })
      // 获取微信sdk签名
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseWXPay']
          });
        }
      })
      this.getCoupon();
    },
    methods: {
      selectPayType(type) {
        if (type == 1) {
          this.payType = 'wechat';
        } else {
          this.payType = 'coupon';
        }
      },
      getCoupon() {
        this.$root.post('/getPayCoupon', {
          pat_id: this.userInfo.user_id,
          doc_id: this.doc_id
        }).then(result => {
          if (result.status) {
            console.log(result.data)
            this.couponData = result.data;
            this.couponCount = result.data.length;
          }
        });
      },
      pay() {
        if (this.payType == 'wechat') {
          this.wechatPay();
        } else {
          this.couponPay();
        }

      },
      couponPay() {
        this.paying = true;
        let _this = this;
        this.$root.post('/addPatientEnrollCoupon', {
          pat_id: this.userInfo.user_id,
          doc_id: this.$route.query.doc_id,
          schedule_id: this.$route.query.schedule_id || null,
          coupon_id: this.couponData[0].coupon_id
        }).then(result => {
          this.orderId = result.order_id;
          this.orderNumber = result.number;
          if (result.status == 1) {
            // 定义通用命令通知消息
            let msg = new RongIMLib.CommandNotificationMessage({
              name: 'OrderedChat',
              data: {
                type: _this.orderType,
                startTime: _this.orderBaseInfo.start_time || null,
                endTime: _this.orderBaseInfo.end_time || null,
              }
            });
            let targetId = _this.$route.query.doc_id.toString();
            let conversationType = RongIMLib.ConversationType.PRIVATE;
            RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
              onSuccess(message) {
                _this.$root.post('/addChatLog', {
                  send_id: _this.userInfo.user_id,
                  to_id: targetId,
                  type: 7,
                  channel_type: 1,
                  content: JSON.stringify(message),
                  create_time: parseInt(message.sentTime / 1000),
                }).then(data => {
                  console.log(data);
                })
                console.log('消息发送成功', message);
              },
              onError(errorCode, message) {
                console.log(errorCode);
              }
            })
            _this.$router.push({
              path: '/patient/order/success',
              query: {
                order_number: _this.orderNumber,
                type: 1,
                order_id: _this.orderId
              }
            })
          } else if (result.status == 2) {
            this.prepaying = false;
            this.hasOrderDate = {
              startTime: result.start_time,
              endTime: result.end_time,
            }
            this.hasOrderShow = true;
          } else {
            this.prepaying = false;
            this.$notify(result.msg);
          }
        })
      },
      wechatPay() {

        this.paying = true;
        this.$root.post('/addPatientEnroll', {
          pat_id: this.userInfo.user_id,
          doc_id: this.$route.query.doc_id,
          schedule_id: this.$route.query.schedule_id || null
        }).then(result => {
          this.orderId = result.order_id;
          this.orderNumber = result.number;
          if (result.status == 1) {
            this.$root.post('/orderPay', {
              order_id: this.orderId
            }).then(data => {
              let _this = this;
              if (data.status == 1) {
                // 调用微信支付接口
                wx.chooseWXPay({
                  timestamp: data.info.timestamp,
                  nonceStr: data.info.nonceStr,
                  package: data.info.package,
                  signType: data.info.signType,
                  paySign: data.info.paySign,
                  success(res) {
                    console.log(res);
                    _this.paying = false;
                    _this.prepaying = false;
                    if (res.errMsg == 'chooseWXPay:ok') {
                      // 定义通用命令通知消息
                      let msg = new RongIMLib.CommandNotificationMessage({
                        name: 'OrderedChat',
                        data: {
                          type: _this.orderType,
                          startTime: _this.orderBaseInfo.start_time || null,
                          endTime: _this.orderBaseInfo.end_time || null,
                        }
                      });
                      let targetId = _this.$route.query.doc_id.toString();
                      let conversationType = RongIMLib.ConversationType.PRIVATE;
                      RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                        onSuccess(message) {
                          _this.$root.post('/addChatLog', {
                            send_id: _this.userInfo.user_id,
                            to_id: targetId,
                            type: 7,
                            channel_type: 1,
                            content: JSON.stringify(message),
                            create_time: parseInt(message.sentTime / 1000),
                          }).then(data => {
                            console.log(data);
                          })
                          console.log('消息发送成功', message);
                        },
                        onError(errorCode, message) {
                          console.log(errorCode);
                        }
                      })
                      _this.$router.push({
                        path: '/patient/order/success',
                        query: {
                          order_number: _this.orderNumber,
                          type: 1,
                          order_id: _this.orderId
                        }
                      })
                    } else if (res.errMsg == 'chooseWXPay:cancel') {
                      _this.$notify('您已取消支付');
                    } else if (res.errMsg == 'chooseWXPay:fail') {
                      _this.$notify('支付出错，请稍后再试');
                    }
                  },
                  cancel(res) {
                    _this.paying = false;
                    _this.prepaying = false;
                    _this.$notify('您已取消支付');
                  },
                  fail(res) {
                    _this.paying = false;
                    _this.prepaying = false;
                    _this.$notify('支付出错，请稍后再试');
                  },
                })
              } else {
                this.paying = false;
                this.prepaying = false;
                _this.$notify(data.msg);
              }
            })
          } else if (result.status == 2) {
            this.prepaying = false;
            this.hasOrderDate = {
              startTime: result.start_time,
              endTime: result.end_time,
            }
            this.hasOrderShow = true;
          } else {
            this.prepaying = false;
            this.$notify(result.msg);
          }
        })
      },
      // 支付预约订单
      confirmOrder() {
        if (!this.isAgree) {
          this.$notify('请先阅读并同意《患者知情同意书》');
          return;
        }
        this.prepaying = true;
        if (this.orderType == 1) {
          this.pay();
        } else {
          this.$root.post('/createEnroll', {
            pat_id: this.userInfo.user_id,
            doc_id: this.$route.query.doc_id
          }).then(result => {
            if (result.status == 1) {
              this.pay();
            } else {
              this.prepaying = false;
              this.hasOrderDate = {
                startTime: result.start_time,
                endTime: result.end_time,
              }
              this.hasOrderShow = true;
            }
          })
        }
      },
      back() {
        this.$router.go(-1);
      },
      cancelOrderAction() {
        this.canceling = true;
        this.$root.post('/cancelPatientEnroll', {
          pat_id: this.userInfo.user_id,
          schedule_id: this.$route.query.schedule_id,
        }).then(data => {
          console.log(data);
          this.canceling = false;
          if (data.status == 1) {
            this.$notify({
              background: '#00848A',
              message: '预约诊疗取消成功'
            });
            this.$router.go(-1);
          } else {
            this.$notify(data.msg);
          }
        })

      }
    },
    filters: {
      orderTimeFormat(stamp, type) {
        switch (type) {
          case 'time':
            {
              return moment.unix(stamp).format('HH:mm');
            };
            break;
          default:
            {
              return moment.unix(stamp).format('MM月DD日 HH:mm');
            }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Payment/payment.vue